import { render, staticRenderFns } from "./ItemGrid.vue?vue&type=template&id=5b0dc912&scoped=true&"
import script from "./ItemGrid.vue?vue&type=script&lang=js&"
export * from "./ItemGrid.vue?vue&type=script&lang=js&"
import style0 from "./ItemGrid.vue?vue&type=style&index=0&id=5b0dc912&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0dc912",
  null
  
)

export default component.exports